export default "__VITE_ASSET__IZEOoNDz__"